import * as service from './service';

export const speakingSessionRoomStructureStore = {
  service,
};
